window.pad = function (str, max) {
    str = str.toString();
    return str.length < max ? window.pad("0" + str, max) : str;
};

window.calcularRangoActividad = function (duracionMeses, mesCompleto, fechaHastaPrevia) {
    duracionMeses = parseInt(duracionMeses, 10) || 1;
    if (duracionMeses < 1) duracionMeses = 1;
    var hoy = new Date();
    var hoyMesInicio = hoy.getFullYear() + '-' + window.pad(hoy.getMonth() + 1, 2) + '-01';

    if (parseInt(mesCompleto, 10) === 1) {
        var startYear, startMonth;
        if (fechaHastaPrevia && fechaHastaPrevia >= hoyMesInicio) {
            var parts = fechaHastaPrevia.split('-');
            var d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10), 1); // mes siguiente al cubierto
            startYear = d.getFullYear();
            startMonth = d.getMonth();
        } else {
            startYear = hoy.getFullYear();
            startMonth = hoy.getMonth();
        }

        var endMonthDate = new Date(startYear, startMonth + duracionMeses, 0);
        return {
            desde: startYear + '-' + window.pad(startMonth + 1, 2) + '-01',
            hasta: endMonthDate.getFullYear() + '-' + window.pad(endMonthDate.getMonth() + 1, 2) + '-' + window.pad(endMonthDate.getDate(), 2)
        };
    } else {
        // Fraccionado / quincenas
        var startYear, startMonth, startDay;
        var endYear, endMonth, endDay;

        if (fechaHastaPrevia && fechaHastaPrevia >= hoyMesInicio) {
            var parts = fechaHastaPrevia.split('-');
            var pYear = parseInt(parts[0], 10);
            var pMonth = parseInt(parts[1], 10) - 1;
            var pDay = parseInt(parts[2], 10);

            if (pDay === 14) {
                startYear = pYear;
                startMonth = pMonth;
                startDay = 15;
                var eDate = new Date(startYear, startMonth + duracionMeses, 14);
                endYear = eDate.getFullYear();
                endMonth = eDate.getMonth() + 1;
                endDay = 14;
            } else {
                var nDate = new Date(pYear, pMonth + 1, 1);
                startYear = nDate.getFullYear();
                startMonth = nDate.getMonth();
                startDay = 1;
                var eDate = new Date(startYear, startMonth + duracionMeses, 0);
                endYear = eDate.getFullYear();
                endMonth = eDate.getMonth() + 1;
                endDay = eDate.getDate();
            }
        } else {
            if (hoy.getDate() < 15) {
                startYear = hoy.getFullYear();
                startMonth = hoy.getMonth();
                startDay = 1;
                var eDate = new Date(startYear, startMonth + duracionMeses, 0);
                endYear = eDate.getFullYear();
                endMonth = eDate.getMonth() + 1;
                endDay = eDate.getDate();
            } else {
                startYear = hoy.getFullYear();
                startMonth = hoy.getMonth();
                startDay = 15;
                var eDate = new Date(startYear, startMonth + duracionMeses, 14);
                endYear = eDate.getFullYear();
                endMonth = eDate.getMonth() + 1;
                endDay = 14;
            }
        }

        return {
            desde: startYear + '-' + window.pad(startMonth + 1, 2) + '-' + window.pad(startDay, 2),
            hasta: endYear + '-' + window.pad(endMonth, 2) + '-' + window.pad(endDay, 2)
        };
    }
};

$(document).on('click','.abreReciboModal', function(){

    var id = this.id.substr(7,25);
    $("#_method").val("PUT");
    $("#formRecibo").attr('action',"recibos/"+id);
    $("#btnDeleteRecibo").css("display","block");
    $("#btnDeleteRecibo").attr('onclick',"document.getElementById('delete-"+id+"').submit()");
    $("#imprime-recibo").val(id);
    $(".campoRecibo").val("");
    $(".campo_muestra").html("");
    var optionsEmisor = "";
    var optionsRecetor;
    $.ajax({
        url: "recibos/"+id,
        type: "GET",
        dataType: "json",
        success: function(data){
            $("#fichaReciboLabel").html("Edición de recibo");
            $.each(data,function(index,value){
                if(value != null){
                    if(index == "empresa_id"){
                        $.ajax({
                            url: "empresas/aux",
                            type: "GET",
                            dataType: "json",
                            success: function(data2){
                                if(value == 0){
                                    optionsEmisor += "<option selected value='0'>Sin empresa</option>";
                                }
                                $.each(data2,function(index2,value2){
                                    if(value2['id'] == value){
                                        optionsEmisor += "<option selected value='"+value2['id']+"'>"+value2['nombre']+"</option>";
                                        datosEmisor(value2['id']);
                                    }else{
                                        optionsEmisor += "<option value='"+value2['id']+"'>"+value2['nombre']+"</option>";
                                    }
                                });
                                $("#emisor").empty();
                                $("#emisor").append(optionsEmisor);
                                $("#emisor_fake").append(optionsEmisor);
                                $("#emisor").hide();
                                $("#emisor_fake").removeClass('d-none');
                            }
                        });
                    }else if(index == "socio_id"){
                        $.ajax({
                            url: "socios/"+value,
                            type: "GET",
                            dataType: "json",
                            success: function(data){
                                rellenaReceptor(data['numero_socio']);
                                $("#receptor").val(data['numero_socio']);
                            }
                        });
                    }else if(index == "lineas"){
                        $("#items-recibo").empty();
                        $("#items-recibo").append(`
                            <div class="cabecera-items" style='position:sticky; top:0; background-color:#fff'> 
                                <div class="cabecera-item-recibo-item">
                                    <p class='m-auto text-center mb-1 fw-bolder'>Item#</p>
                                </div>
                                <div class="cabecera-item-recibo-nombre"'>
                                    <p class='m-auto text-center mb-1 fw-bolder'>Nombre</p>
                                </div>
                                <div class="cabecera-item-recibo-iva">
                                    <p class='m-auto text-center mb-1 fw-bolder'>Iva</p>
                                </div>
                                <div class="cabecera-item-recibo-cantidad">
                                    <p class='m-auto text-center mb-1 fw-bolder'>Cant</p>
                                </div>
                                <div class="cabecera-item-recibo-pvp">
                                    <p class='m-auto text-center mb-1 fw-bolder'>PVP</p>
                                </div>
                                <div class="cabecera-item-recibo-descuento">
                                    <p class='m-auto text-center mb-1 fw-bolder'>Descuento %</p>
                                </div>
                                <div class="cabecera-item-recibo-descuento">
                                    <p class='m-auto text-center mb-1 fw-bolder'>Descuento €</p>
                                </div>
                                <div class="cabecera-item-recibo-importe">
                                    <p class='m-auto text-center mb-1 fw-bolder'>Importe</p>
                                </div>
                                <div class="cabecera-item-recibo-hasta">
                                    <p class='m-auto text-center mb-1 fw-bolder'><i class="bi bi-calendar-event me-1"></i>Hasta</p>
                                </div>
                                <div class="cabecera-item-recibo-borrar"></div>
                            </div>
                        `);
                        $.each(value, function(index2,value2){
                            console.log(value2);
                            $("#items-recibo").append(`
                                <div class="registro-items" style='position:sticky; top:0; background-color:#fff'> 
                                    <div class="registro-item-recibo-item">
                                        <input type="text" name="input_item_id[]" class='form-control m-auto text-center mb-1 input-item-id' readonly value='`+value2['item_id']+`'>
                                    </div>
                                    <div class="registro-item-recibo-nombre">
                                        <input type="text" name="input_item_nombre[]" class='form-control m-auto text-center mb-1 input-item-nombre' value='`+value2['datos']['nombre']+`'>
                                    </div>
                                    <div class="registro-item-recibo-iva">
                                        <input type="number" name="input_item_iva[]" class='form-control m-auto text-center mb-1 input-item-iva' readonly value='`+value2['iva']+`'>
                                    </div>
                                    <div class="registro-item-recibo-cantidad">
                                        <input name="input_item_cantidad[]" class="form-control m-auto text-center input-item-cantidad" type='number' step='1.00' value='`+value2['cantidad']+`' >
                                    </div>
                                    <div class="registro-item-recibo-pvp">
                                        <input name="input_item_pvp[]" class="form-control m-auto text-center input-item-pvp" type='number' step='0.01' value='`+value2['pvp']+`'>
                                    </div>
                                    <div class="registro-item-recibo-descuento">
                                        <input name="input_item_descuento[]" class="form-control m-auto text-center input-item-descuento" type='number' step='0.01' value='`+value2['descuento']+`'>
                                    </div>
                                    <div class="registro-item-recibo-descuento">
                                        <input  class="form-control m-auto text-center input-item-descuento-euro" type='number' step='0.01' value='0'>
                                    </div>
                                    <div class="registro-item-recibo-importe">
                                        <input type="number" step="0.01" name="input_item_importe[]" class='form-control m-auto text-center mb-1 input-item-importe' value="`+value2['importe']+`">
                                    </div>
                                    <div class="registro-item-recibo-hasta">
                                        <input type="date" name="input_item_hasta[]" class='form-control m-auto text-center input-item-hasta mb-1' value='`+value2['fecha_hasta']+`'>
                                    </div>
                                    <div class="registro-item-recibo-borrar">
                                        <a title='Borrar' class='borrar-item' href='#'><i class="bi bi-trash3-fill"></i></a>
                                    </div>
                                </div>
                            `); 
                        });
                    }else{
                        $("#"+index.toLowerCase()).val(value);
                        $("#"+index.toLowerCase()+"_recibo").html(value);
                    }
                }

            });
        }
    }); 
});
$(document).on("submit", "#formRecibo", function (e) {
    var lineas = $(".registro-items").length;
    if (lineas == 0) {
        e.preventDefault();
        Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se puede guardar un recibo sin líneas.",
            confirmButtonColor: "#3085d6",
        });
        return false;
    }
});
$(document).on('click','.nuevoReciboModal', function(){
    $("#_method").val("POST");
    $("#formRecibo").attr('action',"recibos");
    $("#fichaReciboLabel").html("Creación de nuevo recibo");
    $("#btnDeleteRecibo").css("display","none");
    $(".campoRecibo").val("");
    $(".campo_muestra").html("");
    var optionsEmisor;
    $.ajax({
        url: "empresas/aux",
        type: "GET",
        dataType: "json",
        success: function(data){
            $.each(data,function(index,value){
                optionsEmisor += "<option selected value='"+value['id']+"'>"+value['nombre']+"</option>";
                datosEmisor(value['id']);
            });
            $("#emisor").empty();
            $("#emisor").append(optionsEmisor);
            $("#emisor").show();
            $("#emisor_fake").addClass('d-none');
            
            $.ajax({
                url: "recibos/lastSerial/"+$("#emisor").val(),
                type: "GET",
                dataType: "json",
                success: function(data){
                    $("#serial_recibo").html(data);
                    $("#serial_recibo").css('color',"blue");
                    $("#serial_recibo").css('font-weight',"bolder");
                }
            });
        }
    });
    $("#items-recibo").empty();
    $("#items-recibo").append(`
        <div class="cabecera-items" style='position:sticky; top:0; background-color:#fff'> 
            <div class="cabecera-item-recibo-item">
                <p class='m-auto text-center mb-1 fw-bolder'>Item#</p>
            </div>
            <div class="cabecera-item-recibo-nombre"'>
                <p class='m-auto text-center mb-1 fw-bolder'>Nombre</p>
            </div>
            <div class="cabecera-item-recibo-iva">
                <p class='m-auto text-center mb-1 fw-bolder'>Iva</p>
            </div>
            <div class="cabecera-item-recibo-cantidad">
                <p class='m-auto text-center mb-1 fw-bolder'>Cant</p>
            </div>
            <div class="cabecera-item-recibo-pvp">
                <p class='m-auto text-center mb-1 fw-bolder'>PVP</p>
            </div>
            <div class="cabecera-item-recibo-descuento">
                <p class='m-auto text-center mb-1 fw-bolder'>Descuento %</p>
            </div>
            <div class="cabecera-item-recibo-descuento">
                <p class='m-auto text-center mb-1 fw-bolder'>Descuento €</p>
            </div>
            <div class="cabecera-item-recibo-importe">
                <p class='m-auto text-center mb-1 fw-bolder'>Importe</p>
            </div>
            <div class="cabecera-item-recibo-hasta">
                <p class='m-auto text-center mb-1 fw-bolder'><i class="bi bi-calendar-event me-1"></i>Hasta</p>
            </div>
            <div class="cabecera-item-recibo-borrar"></div>
        </div>
    `);
})
$(document).on('change','#emisor',function(){
    var id = $(this).val();
    console.log(id);
    $(".registro-items input").attr('disabled',true);
    $(".empresa-"+id).attr('disabled',false);
    $.ajax({
        url: "recibos/lastSerial/"+id,
        type: "GET",
        dataType: "json",
        success: function(data){
            $("#serial_recibo").html(data);
            $("#serial_recibo").css('color',"blue");
            $("#serial_recibo").css('font-weight',"bolder");
        }
    });
    $.ajax({
        url: "empresas/"+id,
        type: "GET",
        dataType: "json",
        success: function(data){
            $("#emisor-nombre").html(data['nombre']);
            $("#emisor-cif").html(data['cif']);
            $("#emisor-direccion").html(data['direccion']);
            $("#emisor-cpostal").html(data['cpostal']);
            $("#emisor-poblacion").html(data['poblacion']);
            $("#emisor-telefono").html(data['telefono']);
            $("#emisor-web").html(data['web']);
            $("#logo-recibo img").attr('src',"storage/"+data['logo']); 
        }
    });
    recalculoimporte();
    construccionconcepto();
});
$(document).on('change','#receptor',function(){
    rellenaReceptor($(this).val());
});
$(document).on('change','#fecha_emision',function(){
    $("#fecha_emision_recibo").html($(this).val());
});
$(document).on('change','#importe',function(){
    $("#importe_recibo").html($(this).val());
});
$(document).on('change','#fpago',function(){
    $("#fpago_recibo").html($(this).val());
});
$(document).on('change','#iva',function(){
    $("#iva_recibo").html($(this).val());
});
$(document).on('change','#concepto',function(){
    $("#concepto_recibo").addClass('capitalise').html($(this).val());
});
// ITEMS RECIBO - PRODUCTOS
$(document).on('click', '.addproducto', function(){
    $("#listaProductos").modal("show");
    $("#filtro-box-productos").val("");
    $("#contador-productos-sel").text("0 seleccionados");
    $("#productos-lista").html('<div class="p-4 text-center text-muted"><div class="spinner-border spinner-border-sm text-primary me-2"></div>Cargando catálogo de productos...</div>');

    var emisorId = $("#emisor").val();

    $.ajax({
        url: "productos/aux/",
        type: "GET",
        dataType: "json",
        success: function(data){
            var html = `
                <div class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                        <thead class="table-light sticky-top" style="z-index: 1;">
                            <tr>
                                <th style="width: 48%;">Producto</th>
                                <th style="width: 22%;" class="text-center">Stock</th>
                                <th style="width: 20%;" class="text-end">PVP</th>
                                <th style="width: 10%;" class="text-center">Elegir</th>
                            </tr>
                        </thead>
                        <tbody id="tbody-productos">
            `;
            var count = 0;
            $.each(data, function(index, value){
                if(value['stock'] > 0 && value['empresa_id'] == emisorId){
                    count++;
                    var stockClass = value['stock'] > 5 ? 'bg-success-subtle text-success border-success-subtle' : 'bg-warning-subtle text-warning border-warning-subtle';
                    html += `
                        <tr class="producto-fila" data-id="${value['id']}" style="cursor: pointer;">
                            <td class="fw-semibold text-dark text-capitalize">
                                <i class="bi bi-box me-1 text-muted"></i> ${value['nombre']}
                            </td>
                            <td class="text-center">
                                <span class="badge ${stockClass} border px-2 py-1">${value['stock']} ud</span>
                            </td>
                            <td class="text-end fw-bold text-dark">${parseFloat(value['pvp']).toFixed(2)} €</td>
                            <td class="text-center">
                                <input type="checkbox" class="form-check-input check-producto" value="${value['id']}">
                            </td>
                        </tr>
                    `;
                }
            });

            html += `
                        </tbody>
                    </table>
                </div>
            `;

            if(count === 0){
                html = `<div class="p-4 text-center text-muted"><i class="bi bi-inbox fs-2 d-block mb-2 text-secondary"></i>No hay productos con stock disponibles para esta empresa.</div>`;
            }

            $("#productos-lista").html(html);
        }
    });
});

$(document).on('click', '.producto-fila', function(e){
    if(!$(e.target).is('input[type="checkbox"]')){
        var cb = $(this).find('.check-producto');
        cb.prop('checked', !cb.prop('checked')).trigger('change');
    }
});

$(document).on('change', '.check-producto', function(){
    $(this).closest('tr').toggleClass('table-active bg-primary bg-opacity-10', this.checked);
    var totalSel = $('.check-producto:checked').length;
    $("#contador-productos-sel").text(totalSel + (totalSel === 1 ? ' seleccionado' : ' seleccionados'));
});

$(document).on('keyup', '#filtro-box-productos', function(){
    var value = $(this).val().toLowerCase().trim();
    $("#tbody-productos .producto-fila").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
    });
});

$(document).on('click', "#confirmaddproduct", function(){
    var productos = $(".check-producto:checked");
    $.each(productos, function(index, value){
        $.ajax({
            url: "productos/" + $(value).val(),
            type: "GET",
            dataType: "json",
            async: false,
            success: function(data){
                $("#items-recibo").append(`
                    <div class="registro-items" style='position:sticky; top:0; background-color:#fff'> 
                        <div class="registro-item-recibo-item">
                            <input type="text" name='input_item_id[]' class='form-control m-auto text-center mb-1 input-item-id empresa-${data['empresa_id']}' readonly value='Producto-${data['id']}'>
                        </div>
                        <div class="registro-item-recibo-nombre">
                            <input type="text" name='input_item_nombre[]' class='form-control m-auto text-center mb-1 input-item-nombre empresa-${data['empresa_id']}' value='${data['nombre']}'>
                        </div>
                        <div class="registro-item-recibo-iva">
                            <input type="number" name="input_item_iva[]" class='form-control m-auto text-center mb-1 input-item-iva empresa-${data['empresa_id']}' readonly value='${data['iva']}'>
                        </div>
                        <div class="registro-item-recibo-cantidad">
                            <input name="input_item_cantidad[]" class="form-control m-auto text-center input-item-cantidad empresa-${data['empresa_id']}" type='number' step='1.00' value='1'>
                        </div>
                        <div class="registro-item-recibo-pvp">
                            <input name="input_item_pvp[]" class="form-control m-auto text-center input-item-pvp empresa-${data['empresa_id']}" type='number' step='0.01' value='${data['pvp']}'>
                        </div>
                        <div class="registro-item-recibo-descuento">
                            <input name="input_item_descuento[]" class="form-control m-auto text-center input-item-descuento empresa-${data['empresa_id']}" type='number' step='0.01' value='0'>
                        </div>
                        <div class="registro-item-recibo-descuento">
                            <input class="form-control m-auto text-center input-item-descuento-euro empresa-${data['empresa_id']}" type='number' step='0.01' value='0'>
                        </div>
                        <div class="registro-item-recibo-importe">
                            <input type="number" step="0.01" name="input_item_importe[]" class='form-control m-auto text-center input-item-importe mb-1 empresa-${data['empresa_id']}' value='${data['pvp']}'>
                        </div>
                        <div class="registro-item-recibo-hasta">
                            <input type="date" name="input_item_hasta[]" class='form-control m-auto text-center input-item-hasta mb-1 empresa-${data['empresa_id']}' readonly value=''>
                        </div>
                        <div class="registro-item-recibo-borrar">
                            <a title='Borrar' class='borrar-item' href='#'><i class="bi bi-trash3-fill"></i></a>
                        </div>
                    </div>
                `); 
            }
        });
    });
    $("#listaProductos").modal('hide');
    recalculoimporte();
    construccionconcepto();
});

// ITEMS RECIBO - ACTIVIDADES
$(document).on('click', '.addactividad', function(){
    $("#listaActividades").modal("show");
    $("#filtro-box-actividades").val("");
    $("#contador-actividades-sel").text("0 seleccionadas");
    $("#actividades-lista").html('<div class="p-4 text-center text-muted"><div class="spinner-border spinner-border-sm text-success me-2"></div>Cargando catálogo de actividades...</div>');

    var emisorId = $("#emisor").val();

    $.ajax({
        url: "actividades/aux/",
        type: "GET",
        dataType: "json",
        success: function(data){
            var html = `
                <div class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                        <thead class="table-light sticky-top" style="z-index: 1;">
                            <tr>
                                <th style="width: 38%;">Actividad / Tarifa</th>
                                <th style="width: 24%;" class="text-center">Duración</th>
                                <th style="width: 16%;" class="text-center">Cobro</th>
                                <th style="width: 12%;" class="text-end">PVP</th>
                                <th style="width: 10%;" class="text-center">Elegir</th>
                            </tr>
                        </thead>
                        <tbody id="tbody-actividades">
            `;
            var count = 0;
            $.each(data, function(index, value){
                if(value['empresa_id'] == emisorId){
                    count++;
                    var duracion = parseInt(value['duracion_meses'], 10) || 1;
                    var badgeDuracion = '<span class="badge bg-primary-subtle text-primary border border-primary-subtle px-2 py-1"><i class="bi bi-calendar3 me-1"></i>1 mes</span>';
                    if (duracion === 2) badgeDuracion = '<span class="badge bg-info-subtle text-info border border-info-subtle px-2 py-1"><i class="bi bi-calendar3 me-1"></i>2 meses</span>';
                    else if (duracion === 3) badgeDuracion = '<span class="badge bg-info-subtle text-info border border-info-subtle px-2 py-1"><i class="bi bi-calendar3 me-1"></i>3 meses (Trimestral)</span>';
                    else if (duracion === 6) badgeDuracion = '<span class="badge bg-warning-subtle text-warning border border-warning-subtle px-2 py-1"><i class="bi bi-calendar-check me-1"></i>6 meses (Semestral)</span>';
                    else if (duracion === 12) badgeDuracion = '<span class="badge bg-success-subtle text-success border border-success-subtle px-2 py-1"><i class="bi bi-award me-1"></i>12 meses (Anual)</span>';
                    else if (duracion > 1) badgeDuracion = `<span class="badge bg-secondary-subtle text-secondary border border-secondary-subtle px-2 py-1"><i class="bi bi-calendar3 me-1"></i>${duracion} meses</span>`;

                    var badgeCobro = value['mes_completo'] == 1 
                        ? '<span class="badge bg-light text-dark border px-2 py-1">Mes completo</span>' 
                        : '<span class="badge bg-light text-muted border px-2 py-1">Partido</span>';

                    html += `
                        <tr class="actividad-fila" data-id="${value['id']}" style="cursor: pointer;">
                            <td class="fw-semibold text-dark text-capitalize">
                                <i class="bi bi-activity me-1 text-success"></i> ${value['nombre']}
                            </td>
                            <td class="text-center">${badgeDuracion}</td>
                            <td class="text-center">${badgeCobro}</td>
                            <td class="text-end fw-bold text-dark">${parseFloat(value['precio']).toFixed(2)} €</td>
                            <td class="text-center">
                                <input type="checkbox" class="form-check-input check-actividad" value="${value['id']}">
                            </td>
                        </tr>
                    `;
                }
            });

            html += `
                        </tbody>
                    </table>
                </div>
            `;

            if(count === 0){
                html = `<div class="p-4 text-center text-muted"><i class="bi bi-inbox fs-2 d-block mb-2 text-secondary"></i>No hay actividades disponibles para esta empresa.</div>`;
            }

            $("#actividades-lista").html(html);
        }
    });
});

$(document).on('click', '.actividad-fila', function(e){
    if(!$(e.target).is('input[type="checkbox"]')){
        var cb = $(this).find('.check-actividad');
        cb.prop('checked', !cb.prop('checked')).trigger('change');
    }
});

$(document).on('change', '.check-actividad', function(){
    $(this).closest('tr').toggleClass('table-active bg-primary bg-opacity-10', this.checked);
    var totalSel = $('.check-actividad:checked').length;
    $("#contador-actividades-sel").text(totalSel + (totalSel === 1 ? ' seleccionada' : ' seleccionadas'));
});

$(document).on('keyup', '#filtro-box-actividades', function(){
    var value = $(this).val().toLowerCase().trim();
    $("#tbody-actividades .actividad-fila").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
    });
});

$(document).on('click', "#confirmaddactividad", function(){
    var actividades = $(".check-actividad:checked");
    $.each(actividades, function(index, value){
        $.ajax({
            url: "actividades/" + $(value).val(),
            type: "GET",
            dataType: "json",
            async: false,
            success: function(data){
                var prevDate = null;
                $('.registro-items').each(function() {
                    if ($(this).find('.input-item-id').val() === 'Actividad-' + data['id']) {
                        var f = $(this).find('.input-item-hasta').val();
                        if (f) prevDate = f;
                    }
                });

                if (!prevDate && window.socioReciboActual) {
                    if (window.socioReciboActual.assigned_actividades) {
                        $.each(window.socioReciboActual.assigned_actividades, function(i, a) {
                            if (a.id == data['id'] && a.fecha_hasta) {
                                prevDate = a.fecha_hasta;
                            }
                        });
                    }
                    if (!prevDate && window.socioReciboActual.fecha_hasta) {
                        prevDate = window.socioReciboActual.fecha_hasta;
                    }
                }

                var duracion = data['duracion_meses'] || 1;
                var mesCompleto = (data['mes_completo'] !== undefined) ? data['mes_completo'] : 1;
                var rango = window.calcularRangoActividad(duracion, mesCompleto, prevDate);

                $("#items-recibo").append(`
                    <div class="registro-items" style='position:sticky; top:0; background-color:#fff'> 
                        <div class="registro-item-recibo-item">
                            <input type="text" name="input_item_id[]" class='form-control m-auto text-center mb-1 input-item-id empresa-${data['empresa_id']}' readonly value="Actividad-${data['id']}">
                        </div>
                        <div class="registro-item-recibo-nombre">
                            <input name="input_item_nombre[]" class='form-control m-auto text-center mb-1 input-item-nombre empresa-${data['empresa_id']}' value="${data['nombre']}">
                        </div>
                        <div class="registro-item-recibo-iva">
                            <input name="input_item_iva[]" class='form-control m-auto text-center mb-1 input-item-iva empresa-${data['empresa_id']}' readonly value='21'>
                        </div>
                        <div class="registro-item-recibo-cantidad">
                            <input name="input_item_cantidad[]" class="form-control m-auto text-center input-item-cantidad empresa-${data['empresa_id']}" type='number' step='1.00' value='1'>
                        </div>
                        <div class="registro-item-recibo-pvp">
                            <input name="input_item_pvp[]" class="form-control m-auto text-center input-item-pvp empresa-${data['empresa_id']}" type='number' step='0.01' value='${data['precio']}'>
                        </div>
                        <div class="registro-item-recibo-descuento">
                            <input name="input_item_descuento[]" class="form-control m-auto text-center input-item-descuento empresa-${data['empresa_id']}" type='number' step='0.01' value='0'>
                        </div>
                        <div class="registro-item-recibo-descuento">
                            <input class="form-control m-auto text-center input-item-descuento-euro empresa-${data['empresa_id']}" type='number' step='0.01' value='0'>
                        </div>
                        <div class="registro-item-recibo-importe">
                            <input type="number" name="input_item_importe[]" step="0.01" class='form-control m-auto text-center input-item-importe mb-1 empresa-${data['empresa_id']}' value='${data['precio']}'>
                        </div>
                        <div class="registro-item-recibo-hasta">
                            <input type="date" name="input_item_hasta[]" required class='form-control m-auto text-center input-item-hasta mb-1 empresa-${data['empresa_id']}' value='${rango.hasta}'>
                            <input type="hidden" class="input-item-desde" value="${rango.desde}">
                        </div>
                        <div class="registro-item-recibo-borrar">
                            <a title='Borrar' class='borrar-item empresa-${data['empresa_id']}' href='#'><i class="bi bi-trash3-fill"></i></a>
                        </div>
                    </div>
                `); 
            }
        });
    });
    $("#listaActividades").modal('hide');
    recalculoimporte();
    construccionconcepto();
});
$(document).on('click','.borrar-item',function(){
    $(this).parent().parent().remove();
    recalculoimporte();
    construccionconcepto();
});
$(document).on('change','.input-item-descuento',function(){
    var valor_descuento = $(this).val();
    var valor_pvp       = $(this).parent().parent().find(".input-item-pvp").val();
    var valor_cantidad  = $(this).parent().parent().find(".input-item-cantidad").val();
    $(this).parent().parent().find(".input-item-descuento-euro").val(valor_descuento*valor_pvp/100);
    $(this).parent().parent().find(".input-item-importe").val(Math.round10((valor_cantidad*valor_pvp)-((valor_cantidad*valor_pvp)*valor_descuento/100),-2));
    recalculoimporte();
});
$(document).on('change','.input-item-descuento-euro',function(){
    var valor_descuento_euro = $(this).val();
    var valor_pvp       = $(this).parent().parent().find(".input-item-pvp").val();
    var valor_cantidad  = $(this).parent().parent().find(".input-item-cantidad").val();
    $(this).parent().parent().find(".input-item-descuento").val(valor_descuento_euro*100/valor_pvp);
    var valor_descuento =  $(this).parent().parent().find(".input-item-descuento").val();
    $(this).parent().parent().find(".input-item-importe").val(Math.round10((valor_cantidad*valor_pvp)-((valor_cantidad*valor_pvp)*valor_descuento/100),-2));
    recalculoimporte();
});
$(document).on('change','.input-item-cantidad',function(){
    var valor_cantidad  = $(this).val();
    var valor_descuento = $(this).parent().parent().find(".input-item-descuento").val();
    var valor_pvp       = $(this).parent().parent().find(".input-item-pvp").val();
    $(this).parent().parent().find(".input-item-importe").val(Math.round10((valor_cantidad*valor_pvp)-((valor_cantidad*valor_pvp)*valor_descuento/100),-2));
    recalculoimporte();
    construccionconcepto();
});
$(document).on('change','.input-item-importe',function(){
    var valor_cantidad  = $(this).parent().parent().find(".input-item-cantidad").val();
    var valor_pvp       = $(this).parent().parent().find(".input-item-pvp").val();
    var valor_descuento = Math.round10((((valor_cantidad*valor_pvp)-$(this).val())*100)/(valor_cantidad*valor_pvp),-2);
    $(this).parent().parent().find(".input-item-descuento").val(valor_descuento);
    recalculoimporte();
});
$(document).on('change','.input-item-pvp',function(){
    var valor_pvp       = parseFloat($(this).val()) || 0;
    var valor_cantidad  = parseFloat($(this).parent().parent().find(".input-item-cantidad").val()) || 1;
    var valor_descuento = parseFloat($(this).parent().parent().find(".input-item-descuento").val()) || 0;
    $(this).parent().parent().find(".input-item-descuento-euro").val(Math.round10(valor_descuento * valor_pvp / 100, -2));
    $(this).parent().parent().find(".input-item-importe").val(Math.round10((valor_cantidad * valor_pvp) - ((valor_cantidad * valor_pvp) * valor_descuento / 100), -2));
    recalculoimporte();
    construccionconcepto();
});
$(document).on('change keyup','.input-item-nombre',function(){
    construccionconcepto();
});
// Alternancia discreta de comprobantes de control interno (Ctrl + B o Cmd + B)
$(document).on('keydown', function(e) {
    if ($(e.target).is('input, textarea, select')) {
        return;
    }
    if ((e.ctrlKey || e.metaKey) && (e.key === 'b' || e.key === 'B' || e.keyCode === 66)) {
        e.preventDefault();
        var icon = $('.change-recibos-interno');
        if (icon.length) {
            icon.trigger('click');
        }
    }
});
//FUNCIONES
function recalculoimporte(){
    var lineas = $('.registro-items');
    var importe_total = 0.00;
    $.each(lineas,function(){
        if($(this).find('.input-item-importe').prop('disabled') == false){
            importe_total = importe_total + parseFloat($(this).find('.input-item-importe').val());
        }
    });
    $("#importe").val(importe_total).change();
}
function construccionconcepto(){
    var lineas   = $('.registro-items');
    var concepto = "";
    var meses    = ['ENERO','FEBRERO','MARZO','ABRIL','MAYO','JUNIO','JULIO','AGOSTO','SEPTIEMBRE','OCTUBRE','NOVIEMBRE','DICIEMBRE'];
    $.each(lineas,function(index,value){
        if($(this).find('.input-item-id').prop('disabled') == false){
            var cantidad = $(this).find('.input-item-cantidad').val();
            var prefijo = (cantidad > 1) ? cantidad + "x " : "";
            var itemId = $(this).find('.input-item-id').val() || "";
            var nombre = $(this).find('.input-item-nombre').val() || "";
            
            if(itemId.split("-")[0] == "Actividad"){
                var fDesde = $(this).find('.input-item-desde').val() || "";
                var fHasta = $(this).find('.input-item-hasta').val() || "";
                var mesFinIdx = fHasta ? parseInt(fHasta.substr(5,2), 10) - 1 : -1;
                var mesFin = (mesFinIdx >= 0 && mesFinIdx < 12) ? meses[mesFinIdx] : "";
                var mesIniIdx = fDesde ? parseInt(fDesde.substr(5,2), 10) - 1 : -1;
                var mesIni = (mesIniIdx >= 0 && mesIniIdx < 12) ? meses[mesIniIdx] : "";

                var detalle = "";
                if(fDesde && fHasta && mesIni && mesFin && (mesIni !== mesFin || fDesde.substr(0,4) !== fHasta.substr(0,4))){
                    detalle = "Cuota " + mesIni + " a " + mesFin + " " + nombre;
                } else if(mesFin){
                    if(fDesde && fDesde.substr(8,2) == "01"){
                        detalle = "Cuota " + mesFin + " " + nombre;
                    } else if(fHasta) {
                        detalle = "Cuota " + mesFin + " " + nombre + " hasta " + fHasta.substr(8,2)+"-"+fHasta.substr(5,2)+"-"+fHasta.substr(0,4);
                    } else {
                        detalle = "Cuota " + nombre;
                    }
                } else {
                    detalle = "Cuota " + nombre;
                }

                concepto += (concepto ? " // " : "") + prefijo + detalle;
            } else {
                concepto += (concepto ? " // " : "") + prefijo + nombre;
            }
        }
    });
    $("#concepto").val(concepto).change();
}
function rellenaReceptor(numSoc){
    $.ajax({
        url: "socios/aux/"+numSoc,
        type: "GET",
        dataType: "json",
        success: function(data){
            window.socioReciboActual = data;
            $("#receptor-numsoc").html(data['numero_socio']);
            $("#receptor-socio").html(data['nombre']+ " "+data['apellidos']);
            $("#receptor-nif").html(data['dni']);
            $("#receptor-direccion").html(data['direccion']);
            $("#receptor-cpostal").html(data['cpostal']);
            $("#receptor-poblacion").html(data['poblacion']);
            $("#socio_id").val(data['id']);
        }
    });
}
function rellenaConceptoActividad(){
    var concepto = "";
    $.each($(".actividad"),function(index,value){
        if(index == 0){
            concepto = "Cuota " + $(value).html();
        }else{
            concepto += "+ Cuota " + $(value).html(); 
        }
    });
    $.each($(".producto"),function(index,value){
        if(index == 0 && concepto == ""){
            concepto = $(value).html();
        }else{
            concepto += " + "+$(value).html(); 
        }
    });
    $("#concepto").val(concepto).change();
}
function datosEmisor(id){
    $.ajax({
        url: "empresas/aux",
        type: "GET",
        dataType: "json",
        success: function(data){
            $.each(data,function(index,value){
                if(value['id'] == id){
                    $("#emisor-nombre").html(value['nombre']);
                    $("#emisor-cif").html(value['cif']);
                    $("#emisor-direccion").html(value['direccion']);
                    $("#emisor-cpostal").html(value['cpostal']);
                    $("#emisor-poblacion").html(value['poblacion']);
                    $("#emisor-telefono").html(value['telefono']);
                    $("#emisor-web").html(value['web']);
                    $("#logo-recibo img").attr('src',"storage/"+value['logo']);
                }
            });
        }
    });
}
function pad (str, max) {
    str = str.toString();
    return str.length < max ? pad("0" + str, max) : str;
}
(function () {
    /**
     * Ajuste decimal de un número.
     *
     * @param {String}  tipo  El tipo de ajuste.
     * @param {Number}  valor El numero.
     * @param {Integer} exp   El exponente (el logaritmo 10 del ajuste base).
     * @returns {Number} El valor ajustado.
     */
    function decimalAdjust(type, value, exp) {
      // Si el exp no está definido o es cero...
      if (typeof exp === "undefined" || +exp === 0) {
        return Math[type](value);
      }
      value = +value;
      exp = +exp;
      // Si el valor no es un número o el exp no es un entero...
      if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
        return NaN;
      }
      // Shift
      value = value.toString().split("e");
      value = Math[type](+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp)));
      // Shift back
      value = value.toString().split("e");
      return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
    }
  
    // Decimal round
    if (!Math.round10) {
      Math.round10 = function (value, exp) {
        return decimalAdjust("round", value, exp);
      };
    }
    // Decimal floor
    if (!Math.floor10) {
      Math.floor10 = function (value, exp) {
        return decimalAdjust("floor", value, exp);
      };
    }
    // Decimal ceil
    if (!Math.ceil10) {
      Math.ceil10 = function (value, exp) {
        return decimalAdjust("ceil", value, exp);
      };
    }
  })();